module.exports = "<ng-container *ngIf=\"isChecked; then thenBlockOnCheck; else elseBlockNonCheck;\"></ng-container>\n<ng-template #thenBlockOnCheck>\n  <i class=\"fas fa-check-circle on-checked\"></i>\n</ng-template>\n<ng-template #elseBlockNonCheck>\n  <i class=\"far fa-circle\"></i>\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/pages/parts/checkbox/checkbox.component.html
// module id = ../../../../../src/app/pages/parts/checkbox/checkbox.component.html
// module chunks = main